/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import { Checkbox as MuiCheckbox } from '@material-ui/core';
import { CheckboxProps } from '@material-ui/core/Checkbox';

import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';

const Checkbox: React.FC<CheckboxProps> = props => {
  return (
    <MuiCheckbox
      icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
      checkedIcon={<CheckBoxIcon fontSize="small" />}
      color="primary"
      {...props}
    />
  );
};

export default Checkbox;
